import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';
import type { CategoryScore } from '@shared/types';

interface Props {
  categoryScores: CategoryScore[];
}

/** カテゴリ別スコアのレーダーチャート */
export default function ScoreRadar({ categoryScores }: Props) {
  const data = categoryScores.map((c) => ({
    category: c.available === false ? `${c.label}（測定不可）` : c.label,
    score: c.available === false ? null : c.score,
  }));

  const unavailable = categoryScores.filter((c) => c.available === false);

  return (
    <div className="score-radar">
      <ResponsiveContainer width="100%" height={320}>
        <RadarChart data={data} outerRadius="72%">
          <PolarGrid />
          <PolarAngleAxis dataKey="category" tick={{ fontSize: 12, fill: '#444' }} />
          <PolarRadiusAxis angle={90} domain={[0, 100]} tick={{ fontSize: 10 }} />
          <Radar
            name="スコア"
            dataKey="score"
            stroke="#2563eb"
            fill="#2563eb"
            fillOpacity={0.35}
            connectNulls={false}
          />
          <Tooltip
            formatter={(v) =>
              v == null ? ['測定不可（総合スコアの対象外）', 'スコア'] : [`${v} 点`, 'スコア']
            }
          />
        </RadarChart>
      </ResponsiveContainer>
      {unavailable.length > 0 && (
        <div className="score-radar__note muted small">
          <p>
            以下のカテゴリは今回測定できなかったため、総合スコアの計算から除外しています（不当な加点はしていません）。
          </p>
          <ul className="score-radar__reasons">
            {unavailable.map((c) => (
              <li key={c.category}>
                <strong>{c.label}</strong>
                {c.unavailableReason ? `: ${c.unavailableReason}` : ''}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
